import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestChangeProductVariantVisibility } from "./changeProductVariantVisibility.request";

const useChangeProductVariantVisibility = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestChangeProductVariantVisibility,
    ...options
  });
};

export default useChangeProductVariantVisibility;
